
export default {
	props: ['projects','archive_origin_len'],
	methods : {}
}
